import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM } from '@/common'
import {
  queryUsersOrgResource,
  addRoleInfo,
  updateRoleInfo,
  queryRoleDetail,
} from '@/api'
import { isEmpty } from 'lodash'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'role-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      formRef.value?.resetFields?.()
      queryDetail()
    }
  }
)

const deepFormat = (list: any, level = 0) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, code, name, ...p } = item
    return {
      ...p,
      value: id,
      id,
      label: name,
      children: deepFormat(children),
    }
  })
}

const treeList = ref([])
const queryTreeList = async () => {
  const res: any = await queryUsersOrgResource()
  if (res?.code === CODE_ENUM.SUCCESS) {
    console.log(res.data)
    treeList.value = deepFormat(res.data || [])
  }
}
queryTreeList()

const formData = ref({
  name: '',
  resourceIds: [],
  remark: '',
})

const cancel = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields()
}

const rules: any = {
  name: [{ required: true, message: t('CONFIG.rfenter') }],
  resourceIds: [
    {
      required: true,
      message: t('CONFIG.rfselect'),
      type: 'array',
      trigger: 'change',
    },
  ],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const fn = props.data?.id ? updateRoleInfo : addRoleInfo
      loading.value = true
      const res: any = await fn({
        ...formData.value,
        id: props.data?.id,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: res?.msg,
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const queryDetail = async () => {
  const roleId = props?.data?.id
  if (!roleId) {
    return
  }
  const res: any = await queryRoleDetail({
    roleId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { name, resourceIds, remark } = res.data
    formData.value = {
      name,
      resourceIds,
      remark,
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: props.data ? _ctx.$t('CONFIG.reditTitle') : _ctx.$t('CONFIG.rnewTitle'),
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnYes')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnCancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "name",
              label: _ctx.$t('CONFIG.rfname')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('CONFIG.rfnamePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "resourceIds",
              label: _ctx.$t('CONFIG.rfmenu')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tree_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.resourceIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.resourceIds) = $event)),
                  data: treeList.value,
                  multiple: "",
                  "default-expand-all": "",
                  "show-checkbox": ""
                }, null, 8, ["modelValue", "data"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "remark",
              label: _ctx.$t('CONFIG.rfdesc')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.remark,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.remark) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('CONFIG.rfdescPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})